enum TiposItemManipulacao {
    MateriaPrima = 1,
    Embalagem = 2,
    Capsula = 3,
    KitEmbalagem = 4,
    FormulaPadrao = 5,
}

export default TiposItemManipulacao;